<script setup lang="ts">
  import type { IMenuItem } from '@/components/sidebar-menu/types'

  defineOptions({
    inheritAttrs: false
  })

  const props = withDefaults(
    defineProps<{
      item: IMenuItem
      linkClass: string
      activeClass?: string
    }>(),
    {
      activeClass: ''
    }
  )

  const linkClasses = computed(() => [
    props.linkClass,
    props.item.active || props.item.highlighted ? props.activeClass : undefined
  ])
</script>

<template>
  <NuxtLink
    v-bind="$attrs"
    :to="item.href"
    :target="item.target"
    :aria-current="item.active ? 'page' : undefined"
    :class="linkClasses"
    external
  >
    {{ item.name }}
  </NuxtLink>
</template>
